import React, { type ReactElement } from 'react';
import type { NavItemElements, NavItemProps } from '../types';
import NavItem from './nav_item';

interface NavMenuItemsProps {
	children: NavItemElements;
}

export const NavMenuItems = ({ children }: NavMenuItemsProps) => {
	const navItems = children.reduce<Array<ReactElement<NavItemProps>>>(
		(acc, child) => {
			if (child) {
				const { shouldHide, shouldHideMenuItem, title } = child.props;
				if (title && !shouldHideMenuItem) {
					acc.push(
						<NavItem shouldHide={!!shouldHide} key={title} title={title} />,
					);
				}
			}
			return acc;
		},
		[],
	);

	return (
		<>
			<NavItem key="Photos" title="Photos" />
			{navItems}
		</>
	);
};
